import { WorkspaceDataplane } from "src/clients/flow-api";

export const getCloudFormationStackLink = (
  stackName: string,
  region: string,
) => {
  return `https://${
    region ? region : ""
  }.console.aws.amazon.com/cloudformation/home?region=${region}#/stacks?filteringText=${stackName}&filteringStatus=active&viewNested=true`;
};

export const getLambdaLink = (region: string, lambdaName: string) => {
  return `https://console.aws.amazon.com/lambda/home?region=${region}#/functions/${lambdaName}?tab=configuration`;
};

export const getS3BucketLink = (bucketName: string, region: string) => {
  return `https://${region}.console.aws.amazon.com/s3/buckets/${bucketName}?region=${region}&bucketType=general&tab=objects`;
};

export const getInfoEndpoint = (workspace: WorkspaceDataplane) => {
  return `https://${workspace.base_url}/_info`;
};
